import styled from "styled-components";

export const Container = styled.div`
  max-width: 760px;
  margin: 42px auto;

  .page-header {
    margin-left: 28px;
  }

  .description {
    max-width: 556px;
    padding-right: 32px;
  }

  .title {
    font-size: 24px !important;
    letter-spacing: 0.1px;
    color: #eee !important;
  }

  @media (max-width: 450px) {
    .title {
      font-size: 18px !important;
    }
  }

  .detail-text {
    color: ${props => props.theme.white};
    margin-bottom: 32px;
    line-height: 26px;
    font-size: ${props => props.theme.p2b.fs};
    font-family: ${props => props.theme.p2r.ff};

    ul {
      width: 100%;
      list-style-type: none;
      padding: 0px;
      font-family: ${props => props.theme.p2b.ff};
    }
  }
  .paragraph {
    margin-bottom: 32px;
    line-height: 26px;

    a {
      color: ${({ theme }) => theme.white};
      text-decoration: none;
    }
  }

  .paragraph-title {
    font-family: ${props => props.theme.p2b.ff};
  }

  .license-icon {
    position: absolute;
    margin-top: 4px;
    margin-left: 12px;
  }

  .license-card-container {
    margin-bottom: 64px;
  }
`;
